import { render } from "./Controls.vue?vue&type=template&id=5cd13937"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__